<script lang="ts" setup>
/**
 * AggreDaily.vue
 * 時間別チャート本体
 * 
 * 親コンポーネント
 * @/components/parts/aggregation/AggreMain.vue
 */
// ==================================
// import
// ==================================
import { onMounted, watch, ref } from 'vue'

import AxlDailyChart from '@/components/parts/aggregation/charts/daily/AxlDailyChart.vue'
import NearMissDailyChart from '@/components/parts/aggregation/charts/daily/NearMissDailyChart.vue'
import TrafficDailyChart from '@/components/parts/aggregation/charts/daily/TrafficDailyChart.vue'

import { useAggregationFiltersStore } from '@/store/app'

import { DateTime } from 'luxon'

// ==================================
// interface
// ==================================
interface Props {
  toDate: DateTime;
}

// ==================================
// data
// ==================================
const filterStore = useAggregationFiltersStore()

const props = defineProps<Props>()

const dailyLabel = ref<string[]>([])

// ==================================
// watch
// ==================================
watch(() => props.toDate, val => {
  console.log(val)
})

// ==================================
// hook
// ==================================
onMounted(() => {
  // 日次データのグラフラベルを生成する
  dailyLabel.value = setDailyChartLabel(props.toDate)
})

// ==================================
// method
// ==================================
/**
 * 日別チャート用のラベルを生成する
 * @param targetDate - 対象日
 * @returns ラベル文字列
 */
const setDailyChartLabel = (targetDate: DateTime): string[] => {
  let label: string[] = []
  const toDateString = '-' + targetDate.toFormat('MM/dd')
  let work = targetDate.set({
    hour: 0,
    minute: 0,
    second: 0
  })
  for (let i = 0; i < 12; i++) {
    const segment = i == 11 ? work.minus({ hour: 2 }).toFormat('yyyy/MM/dd') + toDateString + ' 00:00' : work.minus({ hour: 2 }).toFormat('HH:mm')
    label.unshift(segment)
  }
  return label
}
</script>
<template>
  <div class="aggre-daily">
    <NearMissDailyChart
      v-if="filterStore.$state.mode.category === 1"
      :to-date="toDate"
      :label="dailyLabel"
    />
    <TrafficDailyChart
      v-if="filterStore.$state.mode.category === 2"
      :to-date="toDate"
      :label="dailyLabel"
    />
    <AxlDailyChart
      v-if="filterStore.$state.mode.category === 3"
      :to-date="toDate"
      :label="dailyLabel"
    />
  </div>
</template>
<style lang="scss" scoped>
  .aggre-daily {
    width: 100%;
    height: 40vh;
    border: 1px #eee solid;
    :deep(canvas) {
      height: 40vh;
    }
  }
</style>
